import Form from './CashBoxesForm';
import React, { Component } from 'react';
import Card from 'Utils/Cards/cardFormulario';
import LoadMask from 'Utils/LoadMask/LoadMask';

export default class CashBoxesCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar caja',
        password: false,
    }

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar caja'
            });
        }
    }

    render() {

        const {
            create,
            update
        } = this.props;
        
        const {
            updateData,
            cargando 
        } = this.props;

        return (
            <div className="content">
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div className="fields">
                                        <div className="top-title">
                                            CAJA
                                        </div>
                                        <Form
                                            onSubmit={update}
                                            updateData={updateData}
                                            editando={true}
                                        />
                                    </div>
                            :
                                <div className="fields">
                                    <div className="top-title">
                                        CREAR CAJA
                                    </div>
                                    <Form onSubmit={create}/>
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
